// schoolDropout
export const FETCH_SCHOOL_DROPOUTS_INIT = "schoolDropout@FETCH_SCHOOL_DROPOUTS_INIT"
export const FETCH_SCHOOL_DROPOUTS_SUCCEDED = "schoolDropout@FETCH_SCHOOL_DROPOUTS_SUCCEDED"
export const FETCH_SCHOOL_DROPOUTS_FAILED = "schoolDropout@FETCH_SCHOOL_DROPOUTS_FAILED"

export const CLEAR_SCHOOL_DROPOUT = "schoolDropout@CLEAR_SCHOOL_DROPOUT"

export const CREATE_SCHOOL_DROPOUT_INIT = "schoolDropout@CREATE_SCHOOL_DROPOUT_INIT"
export const CREATE_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@CREATE_SCHOOL_DROPOUT_SUCCEDED"
export const CREATE_SCHOOL_DROPOUT_FAILED = "schoolDropout@CREATE_SCHOOL_DROPOUT_FAILED"

export const FETCH_SCHOOL_DROPOUT_INIT = "schoolDropout@FETCH_SCHOOL_DROPOUT_INIT"
export const FETCH_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@FETCH_SCHOOL_DROPOUT_SUCCEDED"
export const FETCH_SCHOOL_DROPOUT_FAILED = "schoolDropout@FETCH_SCHOOL_DROPOUT_FAILED"

export const EDIT_SCHOOL_DROPOUT_INIT = "schoolDropout@EDIT_SCHOOL_DROPOUT_INIT"
export const EDIT_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@EDIT_SCHOOL_DROPOUT_SUCCEDED"
export const EDIT_SCHOOL_DROPOUT_FAILED = "schoolDropout@EDIT_SCHOOL_DROPOUT_FAILED"

export const DEACTIVATE_SCHOOL_DROPOUT_INIT = "schoolDropout@DEACTIVATE_SCHOOL_DROPOUT_INIT"
export const DEACTIVATE_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@DEACTIVATE_SCHOOL_DROPOUT_SUCCEDED"
export const DEACTIVATE_SCHOOL_DROPOUT_FAILED = "schoolDropout@DEACTIVATE_SCHOOL_DROPOUT_FAILED"

export const DELETE_SCHOOL_DROPOUT_INIT = "schoolDropout@DELETE_SCHOOL_DROPOUT_INIT"
export const DELETE_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@DELETE_SCHOOL_DROPOUT_SUCCEDED"
export const DELETE_SCHOOL_DROPOUT_FAILED = "schoolDropout@DELETE_SCHOOL_DROPOUT_FAILED"

export const CANCEL_SCHOOL_DROPOUT_INIT = "schoolDropout@CANCEL_SCHOOL_DROPOUT_INIT"
export const CANCEL_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@CANCEL_SCHOOL_DROPOUT_SUCCEDED"
export const CANCEL_SCHOOL_DROPOUT_FAILED = "schoolDropout@CANCEL_SCHOOL_DROPOUT_FAILED"

export const ACTIVATE_SCHOOL_DROPOUT_INIT = "schoolDropout@ACTIVATE_SCHOOL_DROPOUT_INIT"
export const ACTIVATE_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@ACTIVATE_SCHOOL_DROPOUT_SUCCEDED"
export const ACTIVATE_SCHOOL_DROPOUT_FAILED = "schoolDropout@ACTIVATE_SCHOOL_DROPOUT_FAILED"

export const TRANSFORME_SCHOOL_DROPOUT_INIT = "schoolDropout@TRANSFORME_SCHOOL_DROPOUT_INIT"
export const TRANSFORME_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@TRANSFORME_SCHOOL_DROPOUT_SUCCEDED"
export const TRANSFORME_SCHOOL_DROPOUT_FAILED = "schoolDropout@TRANSFORME_SCHOOL_DROPOUT_FAILED"

export const QUALIFY_SCHOOL_DROPOUT_INIT = "schoolDropout@QUALIFY_SCHOOL_DROPOUT_INIT"
export const QUALIFY_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@QUALIFY_SCHOOL_DROPOUT_SUCCEDED"
export const QUALIFY_SCHOOL_DROPOUT_FAILED = "schoolDropout@QUALIFY_SCHOOL_DROPOUT_FAILED"

export const CLOSE_SCHOOL_DROPOUT_INIT = "schoolDropout@CLOSE_SCHOOL_DROPOUT_INIT"
export const CLOSE_SCHOOL_DROPOUT_SUCCEDED = "schoolDropout@CLOSE_SCHOOL_DROPOUT_SUCCEDED"
export const CLOSE_SCHOOL_DROPOUT_FAILED = "schoolDropout@CLOSE_SCHOOL_DROPOUT_FAILED"
